import { WorkflowActionType } from '@/graphql/generated/schemas'

type WorkflowActionLike = {
  type: WorkflowActionType
}

export const getLastWorkflowAction = <T>(
  workflowActions: readonly T[]
): T | null => workflowActions[workflowActions.length - 1] ?? null

export const isTerminalWorkflowAction = (
  workflowAction: WorkflowActionLike | null | undefined
): boolean => workflowAction?.type === WorkflowActionType.End
